import {fetch} from "utils/dataAccess";

export async function getWmsItems(params = '') {
    const response = await fetch(`/w_m_s_items?${params}`);

    if (!response.ok) throw new Error('Failed to retrieve wms items');

    return (await response.json())['hydra:member'];
}

export async function getWmsItemsFromSpecialOrders(param) {
    const response = await fetch(`/w_m_s_items/specialOrderItems${param}`);
    if (!response.ok) throw new Error('Failed to retrieve special order items');
    return await response.json();
}

export async function getDashboardWmsItemsCount(currentInventoryId, statuses) {
    const response = await fetch(`/wms/dashboard/${currentInventoryId}?statuses=${JSON.stringify(statuses)}`);

    if (!response.ok) throw new Error('Failed to retrieve wms items count');

    return (await response.json());
}

export function getWmsItemsForPacking(currentInventory) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_items/to_pack?inventoryId=${currentInventory.id}`)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved[0])
                })
            })
            .catch(error => reject(error));
    });
}

export function wmsItemSort(wmsItemId, containerIRI) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_items/sort/" + wmsItemId, {
                method: "PATCH",
                headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
                body: JSON.stringify({
                wmsContainer: "/w_m_s_containers/"+containerIRI
            })
        }).then(response => {
            resolve(response)
        })
    })
}

export function packShipmentItem(itemId) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_items/packMono/" + itemId)
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export async function wmsItemInTrolley(wmsItem, containerBarcode) {
    const response = await fetch(`w_m_s_items/in_trolley/${wmsItem.id}`, {
        method: 'PATCH',
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({
            wmsContainerBarcode: containerBarcode,
        })
    });

    if (!response.ok) throw new Error('Failed to put wms item in trolley');

    return response.json();
}

export function itemCancelled(itemId, cancellationReason, addReasonToLineItem = false) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_items/cancelled/" + itemId, {
            method: "PATCH",
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
            body: JSON.stringify({
                cancellationReason: "/cancellation_reasons/" + cancellationReason,
                addReasonToLineItem: addReasonToLineItem
            })
        })
            .then((response) => {
                response.json().then((retrieved) => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}

export async function itemNotFound(itemId) {
    const response = await fetch("/w_m_s_items/not_found/" + itemId, {
        method: "PATCH",
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({}),
    });

    return await response.json();
}

export async function itemUnavailable(itemId) {
    const response = await fetch("/w_m_s_items/unavailable/" + itemId, {
        method: "PATCH",
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: JSON.stringify({}),
    });

    return await response.json();
}

export async function wmsItemRemoveFromTrolley(wmsItem) {
    const response = await fetch(`/w_m_s_items/remove_from_trolley/${wmsItem.id}`, {
        method: 'PATCH',
        headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        body: '{}'
    });

    if (!response.ok) throw new Error('Failed to remove wms item from trolley');

    return response.json();
}
